var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropup go-comments-drop images" }, [
    _c(
      "button",
      {
        staticClass: "btn",
        staticStyle: { padding: "0" },
        attrs: {
          disabled: _vm.countImageFiles(_vm.comment.files) === 0,
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("i", { staticClass: "go-icon-20 go-icon-library-photo" }),
        _vm._v(" "),
        _c("em", [_vm._v(_vm._s(_vm.countImageFiles(_vm.comment.files)))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "go-panel" }, [
          _c("div", { staticClass: "go-panel-body" }, [
            _c(
              "ol",
              { staticClass: "go-comments-attach images" },
              [
                _vm.comment.files && _vm.countImageFiles(_vm.comment.files) > 0
                  ? [
                      _vm._l(_vm.comment.files, function (file, idx) {
                        return [
                          file.contentType.includes("png") ||
                          file.contentType.includes("jpg") ||
                          file.contentType.includes("jpeg")
                            ? _c(
                                "li",
                                {
                                  key: "comment-" + idx,
                                  staticClass: "image-item",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onClickImg(file.storedName)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "hover-enlarge",
                                        attrs: {
                                          width: "68px",
                                          height: "68px",
                                          alt: file.originalName,
                                          src: file.storedName,
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "image-tooltip" }, [
                                    _c("img", {
                                      attrs: {
                                        src: file.storedName,
                                        alt: file.originalName,
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }